import styled from "styled-components";
import { BLACK_0, BLACK_3, MAIN_GREEN, WHITE } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH, PC_LAYOUT_LENGTH } from "constants/UIConstants";
export const Wrapper = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: ${(props) => (props.isActive ? "none" : "flex")};
  justify-content: center;
  background-color: black;
  height: auto;
  z-index: 999;

  @media screen and (min-width: ${MOBILE_LAYOUT_LENGTH}) and (max-width: ${PC_LAYOUT_LENGTH}) {
    padding: 0 20px;
  }
`;
export const Container = styled.div`
  width: 100%;
  padding: 0 10rem;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: black;
  @media screen and (max-width: ${PC_LAYOUT_LENGTH}) {
    padding: 0;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    height: 6rem;
    display: flex;
    padding: 0 20px;

    justify-content: space-between;
    align-items: center;
    position: fixed;
    z-index: 999;
    background-color: black;
  }
`;

export const Logo = styled.div`
  cursor: pointer;
  display: ${(props) => (props.isActive ? "none" : "flex")};
`;
export const LogoImg = styled.img`
  width: 10.5rem;
  height: 3.6rem;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 8.7rem;
    height: 3rem;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  height: 2.1rem;
  gap: 4.2rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: flex;
    gap: 2.5rem;
  }
`;

export const PcMenu = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 5rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
export const Menu = styled.span`
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.1rem;
  display: flex;
  padding-bottom: 2.6rem;
  color: ${(props) => (props.isSelected ? MAIN_GREEN : "white")};
  & > div {
    margin-right: 0.2rem;
  }

  & > img {
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 0.25rem;
    /* transform: ${(props) => (props.isSelected ? " rotateX(180deg)" : "")}; */
  }

  &:hover {
    cursor: pointer;
    color: ${MAIN_GREEN};
    & > img {
      /* transform: rotateX(180deg); */
      display: flex;
      align-items: center;
    }
  }

  /* border-bottom: ${(props) => (props.isSelected ? "2px solid white" : "")}; */
`;

export const SideMenuWrapper = styled.div`
  position: absolute;
  border: 1px solid #363636;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 0.5rem;
  /* display: none; */
  overflow: hidden;
`;

export const SideMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 2.4rem;
  background-color: #222222;
  min-width: 15.5rem;
`;

export const SideMenu = styled.div`
  padding: 1.5rem 2.5rem 1.5rem 1.5rem;
  border-bottom: 1px solid #363636;
  cursor: pointer;
  &:hover {
    color: ${MAIN_GREEN};
  }
  &:last-child {
    border-bottom: none;
  }
`;
export const SketchScan = styled.a`
  border: 1px solid ${BLACK_3};
  width: 12rem;
  height: 3rem;
  border-radius: 0.5rem;
  display: flex;
  padding: 0.3rem 1rem;
  text-decoration: none;
  color: white;
  justify-content: space-between;
  align-items: center;
  display: ${(props) => (props.isActive ? "none" : "flex")};

  & > img {
    width: 1.6rem;
    height: 1.6rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
  }
`;
export const SketchScanText = styled.span`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
    display: flex;
    align-items: center;
  }
`;

export const SideWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: ${(props) => (props.isActive ? "100%" : "40%")};
    justify-content: ${(props) => (props.isActive ? "space-between" : "center")};
  }
`;

export const LanguageSelector = styled.div`
  width: 9.6rem;
  height: 3rem;

  border: 1px solid ${BLACK_3};
  border-radius: 0.5rem;
  overflow: hidden;

  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: ${(props) => (props.isActive ? "flex" : "none")};
  }
`;

export const KOR = styled.span`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: ${(props) => (props.currentLanguage === "ko" ? `${BLACK_0}` : `${WHITE}`)};
  background-color: ${(props) => (props.currentLanguage === "ko" ? `${MAIN_GREEN}` : "")};
  font-weight: ${(props) => (props.currentLanguage === "ko" ? 500 : 300)};
  &:hover {
    color: ${(props) => (props.currentLanguage === "ko" ? `black` : MAIN_GREEN)};
  }
`;
export const ENG = styled.span`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: ${(props) => (props.currentLanguage === "en" ? `${BLACK_0}` : `${WHITE}`)};
  background-color: ${(props) => (props.currentLanguage === "en" ? `${MAIN_GREEN}` : "")};
  font-weight: ${(props) => (props.currentLanguage === "en" ? 500 : 300)};
  &:hover {
    color: ${(props) => (props.currentLanguage === "en" ? `black` : MAIN_GREEN)};
  }
`;

export const SketchScanImg = styled.img`
  width: 1.6rem;
  height: 1.6rem;
`;
export const MenuBtn = styled.div`
  padding-top: 0.3rem;
  & > img {
    width: 2.4rem;
    height: 2.4rem;
  }

  @media screen and (min-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: block;
  }
`;
